module.exports = __webpack_public_path__ + "img/MilesVerrall_140x140_rund.81f12c12.jpg";